"use client";

import * as React from "react";
import { DayPicker, type DayPickerProps } from "react-day-picker";
import { cn } from "@/utils/utils";
import { styleDrivers } from "@/utils/componentStyle";
import 'react-day-picker/src/style.module.css';

export type CalendarProps = DayPickerProps;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  const isRangeMode = (props as any)?.mode === "range";
  const monthsToShow = (props as any)?.numberOfMonths ?? (isRangeMode ? 2 : 1);
  const pagedNav = (props as any)?.pagedNavigation ?? isRangeMode;

  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      navLayout="after"
      className={cn("p-0", className)}
      classNames={{
        months: styleDrivers.calendar.months,
        month: styleDrivers.calendar.month,
        month_caption: styleDrivers.calendar.monthCaption,
        caption: styleDrivers.calendar.caption,
        caption_label: styleDrivers.calendar.captionLabel,
        nav: styleDrivers.calendar.nav,
        nav_button: styleDrivers.calendar.navButton,
        root: styleDrivers.calendar.root,
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: styleDrivers.calendar.table,
        head_row: styleDrivers.calendar.headRow,
        head_cell: styleDrivers.calendar.headCell,
        row: styleDrivers.calendar.row,
        cell: styleDrivers.calendar.cell,
        day: styleDrivers.calendar.day,
        day_selected: styleDrivers.calendar.daySelected,
        day_today: styleDrivers.calendar.dayToday,
        day_outside: styleDrivers.calendar.dayOutside,
        day_disabled: styleDrivers.calendar.dayDisabled,
        day_range_middle: styleDrivers.calendar.dayRangeMiddle,
        day_hidden: styleDrivers.calendar.dayHidden,
        range_start: styleDrivers.calendar.rangeStart,
        range_end: styleDrivers.calendar.rangeEnd,
        selected: styleDrivers.calendar.selected,
        weekdays: styleDrivers.calendar.weekdays,
        ...classNames,
      }}
      numberOfMonths={monthsToShow}
      pagedNavigation={pagedNav}
      {...props}
    />
  );
}

Calendar.displayName = "Calendar";

export { Calendar };
